import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';

import BuildForm from '../../components/BuildForm/BuildForm';
import GitlabLoginButton from '../../components/GitlabLoginButton/GitlabLoginButton';
import { checkFastfileExists, getBranches, getClients, getTags, sendBuildAndroid } from '../../utils/services/gitlab-service';
import PageDefault from '../PageDefault/PageDefault';

import './BuildAndroid.scss';
import { StorageEnum } from '../../utils/enumerators/Storage.enum';
import { getGitLabTokens } from '../../utils/services/service';

function BuildAndroid() {
	const [gitLabState, setGitLabState] = useState(true);
	const [tags, setTags] = useState([]);
	const [branches, setBranches] = useState([]);
	const [selectedTarget, setSelectedTarget] = useState(null);
	const [clients, setClients] = useState([]);
	const [sequential, setSequential] = useState('');
	const [version, setVersion] = useState('');
	const [fastfileExists, setFastfileExists] = useState(false);

	function onChangeTarget(tag) {
		setSelectedTarget(tag);
	}

	function onSubmit(selectedClients, _, selectedSequential, releaseNotes, target, automaticRelease, skipDeploy) {
		sendBuildAndroid(selectedClients, selectedTarget, selectedSequential, version, releaseNotes, automaticRelease, skipDeploy, fastfileExists);

		let title = 'Build Enviada!';
		let text = 'A build foi enviada para o GitLab! Acompanhe seu andamento pelo dashbord.';

		if (selectedClients.length > 1) {
			title = 'Build enviadas!';
			text = 'As builds foram enviadas para o Gitlab! Acompanhe os seus andamentos pelo dashbord.';
		}

		if (target && releaseNotes) {
			localStorage.setItem(`${StorageEnum.RELEASE_NOTES}-${target}-android`, releaseNotes);
		}

		Swal.fire({
			icon: 'success',
			title,
			text,
			buttons: {
				confirm: 'OK',
			},
		}).then(() => {
			window.location.reload(false);
		});
	}

	//Ao iniciar a tela
	useEffect(() => {
		getGitLabTokens()
			.then(() => {
				getTags()
					.then((tagList) => {
						setTags(tagList);
						getBranches()
							.then((branchList) => {
								setBranches(branchList);
							})
							.catch((_) => {
								setGitLabState(false);
							});
					})
					.catch(() => {
						setGitLabState(false);
					});
			})
			.catch(() => {
				setGitLabState(false);
			});
	}, []);

	//Quando mudar o target
	useEffect(async () => {
		setClients([]);

		if (selectedTarget) {
			getClients(selectedTarget, true)
				.then(({ clients, sequential, version }) => {
					setTimeout(() => {
						setClients(clients);
						setSequential(sequential);
						setVersion(version);
					}, 500);
				})

				.catch(() => {
					setGitLabState(false);
					setClients([]);
				});
		}

		setFastfileExists(await checkFastfileExists(selectedTarget, false));
	}, [selectedTarget]);
	return (
		<PageDefault>
			<div className="app-main">
				<div className="app-header">Geração de Build Android</div>
				{!gitLabState && (
					<div className="message">
						<span>Você não está logado ou não possui permissão do projeto.</span>
						<GitlabLoginButton />
					</div>
				)}
				{gitLabState && (
					<>
						{tags.length > 0 && (
							<BuildForm
								tags={tags}
								branches={branches}
								clients={clients}
								onChangeTarget={onChangeTarget}
								onSubmit={onSubmit}
								sequential={sequential}
								android={true}
								fastfileExists={fastfileExists}
							/>
						)}
						{((tags.length === 0 && branches.length == 0) || (selectedTarget && clients.length === 0)) && <span className="message">Carregando...</span>}
					</>
				)}
			</div>
		</PageDefault>
	);
}

export default BuildAndroid;
